import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import { Radio } from 'antd';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class AccountMessageForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    isExternal: false,
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  onCancel = () => {
    this.setState({
      editorState: EditorState.createEmpty()
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { onSubmit } = this.props;
    const { editorState, isExternal } = this.state;
    const text = editorState.getCurrentContent();

    if (text.hasText()) {
      onSubmit({
        message: convertToRaw(text),
        isExternal
      });
      this.setState({
        editorState: EditorState.createEmpty()
      });
    }
  };

  onIsExternalChange = e => {
    this.setState({ isExternal: e.target.value });
  };

  render() {
    const { editorState, isExternal } = this.state;
    const { t } = this.props;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={this.onEditorStateChange}
        />

        <div style={{ marginBottom: '30px' }}>
          <Radio.Group onChange={this.onIsExternalChange} value={isExternal}>
            <Radio value={false}>{t('Interná komunikácia')}</Radio>
            <Radio value={true}>{t('Externá komunikácia')}</Radio>
          </Radio.Group>
        </div>

        <Button size="default" type="primary" htmlType="submit">
          {t('Pridať')}
        </Button>
        <Button size="default" className="btn-inline" onClick={this.onCancel}>
          {t('Zmazať')}
        </Button>
      </Form>
    );
  }
}

export default translate()(AccountMessageForm);



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountMessageForm.js